// Model.js
// -----------------------
// @module Case
define("ProductSpecification.Model",
    [
        "SCModel",
        "Backbone",
        "Utils"
    ],
    function (
        SCModelModule,
        Backbone,
        Utils
    ) {
        "use strict";

        // @class Case.Fields.Model @extends Backbone.Model
        return Backbone.Model.extend({


            //@property {String} urlRoot
            urlRoot: Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    "services/ProductSpecification.Service.ss"
                )
            )

        });
    });
